import { render, staticRenderFns } from "./OffersAnimationSection.vue?vue&type=template&id=3962d46b&scoped=true"
import script from "./OffersAnimationSection.vue?vue&type=script&lang=ts"
export * from "./OffersAnimationSection.vue?vue&type=script&lang=ts"
import style0 from "./OffersAnimationSection.vue?vue&type=style&index=0&id=3962d46b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3962d46b",
  null
  
)

export default component.exports